import { createSvgIcon } from '@mui/material/utils';
import React, { memo } from 'react';
const SvgIcon = createSvgIcon([
    React.createElement("path", { key: '0', d: 'M0,0h24v24H0V0z', fill: 'none' }),
    React.createElement("path", { key: '1', d: 'M12,2c-4.2,0-8,3.22-8,8.2c0,3.32,2.67,7.25,8,11.8c5.33-4.55,8-8.48,8-11.8C20,5.22,16.2,2,12,\n    2z M12,12c-1.1,0-2-0.9-2-2 c0-1.1,0.9-2,2-2c1.1,0,2,0.9,2,2C14,11.1,13.1,12,12,12z' }),
], 'GeofenceMarker');
const GeofenceMarkerIcon = function (props) {
    return (React.createElement(SvgIcon, Object.assign({ xmlns: 'http://www.w3.org/2000/svg', xmlnsXlink: 'http://www.w3.org/1999/xlink', sx: {
            'path:nth-of-type(2)': {
                fill: props.htmlColor,
            },
        } }, props)));
};
export default memo(GeofenceMarkerIcon);
